import { gql } from '@apollo/client';

export const GET_ALL_POSTS = gql`
    query Query {
        posts {
            _id
            user {
                _id
                username
                idme {
                    status {
                        group
                        subgroups
                        verified
                    }
                }
            }
            iconColor
            body
            solutions {
                _id
                solution
                upVotes
                downVotes
                rankedVotes {
                    userId
                    rank
                }
            }
            issues {
                category
                issues
            }
            civicInfo
            latitude
            longitude
            nearby
            createdAt
        }
    }
`;

export const GET_POSTS_IN_BOUNDS = gql`
    query PostsInBounds($minLat: Float!, $minLon: Float!, $maxLat: Float!, $maxLon: Float!) {
        postsInBounds(minLat: $minLat, minLon: $minLon, maxLat: $maxLat, maxLon: $maxLon) {
            _id
            user {
                _id
                username
                idme {
                    status {
                        group
                        subgroups
                        verified
                    }
                }
            }
            iconColor
            body
            solutions {
                _id
                solution
                upVotes
                downVotes
                rankedVotes {
                    userId
                    rank
                }
            }
            issues {
                category
                issues
            }
            civicInfo
            latitude
            longitude
            nearby
            createdAt
        }
    }
`;

export const GET_HISTORY = gql`
    query Query {
        posts {
            _id
            user {
                _id
                username
            }
            iconColor
            body
            solutions {
                _id
                solution
                upVotes
                downVotes
                rankedVotes {
                    userId
                    rank
                }
            }
            issues {
                category
                issues
            }
            civicInfo
            latitude
            longitude
            nearby
            createdAt
        }
    }
`;

export const GET_ONE_POST = gql`
    query ($id: ID!) {
        post(_id: $id) {
            _id
            user {
                _id
                username
                idme {
                    status {
                        group
                        subgroups
                        verified
                    }
                }
            }
            iconColor
            body
            solutions {
                _id
                solution
                upVotes
                downVotes
                rankedVotes {
                    userId
                    rank
                }
            }
            issues {
                category
                issues
            }
            civicInfo
            latitude
            longitude
            createdAt
            nearby
        }
    }
`;
export const GET_COMMENTS = gql`
    query ($id: ID!) {
        post(_id: $id) {
            _id
            comments {
                _id
                userId
                postId
                body
                createdAt
            }
        }
    }
`;

export const GET_ME = gql`
  query me {
    me {
      _id
      username
      iconColor
    }
  }
`;
